export default "__VITE_ASSET__DQa0HSej__"